import store from '@/store/store'
import JsUtils from '@/util/JsUtils'

class UserUtil {
  static isInRol (rolName) {
    if (store.state.userInfo !== null) {
      for (let i = 0; i < store.state.userInfo.roles.length; i++) {
        let rol = store.state.userInfo.roles[i]
        if (rol.name.toUpperCase() === rolName.toUpperCase()) {
          return true
        }
      }
    }
    return false
  }

  static getConfigValue (key, defValue = undefined) {
    if (!JsUtils.isEmpty(store.state.userInfo) &&
      !JsUtils.isEmpty(store.state.userInfo.configuraciones) &&
      store.state.userInfo.configuraciones.hasOwnProperty(key)) {
      return store.state.userInfo.configuraciones[key]
    }
    return defValue
  }
}

export default UserUtil



// WEBPACK FOOTER //
// ./src/customization/GlobalBPOCore/Util/UserUtil.js